import SockJs from 'sockjs-client'
import StompJs from 'stompjs'
import pathUtils from '../util/pathUtils'

const END_POINT_URL = pathUtils.getContextPath('/framework-stomp-endpoint')

export default {
  connect: function (header, successHandler, failureHandler) {
    let sockClient = new SockJs(END_POINT_URL)
    let stompClient = (StompJs.Stomp || StompJs).over(sockClient)
    stompClient.connect(header || {}, (frame) => {
      if (successHandler) {
        successHandler(frame, stompClient)
      }
    }, (frame) => {
      if (failureHandler) {
        failureHandler(frame)
      }
    })
    // 取消log打印
    stompClient.debug = null
    return stompClient
  }
}
